module.exports = __webpack_public_path__ + "static/media/hero.57e1e9a0.jpg";